import React, { useReducer, useContext, useState } from 'react';
import api from './ApiCall';
import { TEST_LIST, QUESTION, ANSRESULT, TEST_RESULT, DashContext, LoginContext, CommonContext } from '../constant/ActionTypes';
import { dashRecuder } from '../reducer/dashRecuder';
import Loader from './../../common/Loader/Loader';

const initialState = {
    testList: [],
    question: {},
    ansresult: [],
    testResult: ''
}

const DashProvider = (props) => {
    const loginContext = useContext(LoginContext);
    const commonContext = useContext(CommonContext);

    const [dashtState, dispatch] = useReducer(dashRecuder, initialState);

    const [showLoader, setShowLoader] = useState(false);

    const getDashList = () => {
        if (loginContext && loginContext.loginDetails && loginContext.loginDetails.id) {
            api({ contentType: true, auth: true }).get(`DashboardService/getAll/user/${loginContext.loginDetails.id}`)
            .then((response) => {
                if (response.data.status.toLowerCase() === 'success') {
                    dispatch({
                        type: TEST_LIST,
                        payload: response.data.result
                    });
                    if (!(response.data.result && response.data.result.length > 0)) {
                        commonContext.updateLoaderMsg('No data found')
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }

    const clearDashList = () => {
        dispatch({
            type: TEST_LIST,
            payload: []
        });
    }

    const clearPrepare = () => {
        dispatch({
            type: QUESTION,
            payload: {}
        });
    }

    const getDashPrepare = (user_id, module_id, attempt) => {
        // setShowLoader(true);
        let data = {
            module_id,
            user_id,
            attempt
        }
        api({ contentType: true, auth: true }).post('TakeTestService/prepare', data)
        .then((response) => {
            if (response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: QUESTION,
                    payload: response.data
                });
                if (response.data.message === 'No questions to fetch') {
                    commonContext.updateLoaderMsg('No data found');
                }
            } else {
                commonContext.updateLoaderMsg('No data found');
            }
            // setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            // setShowLoader(false);
        });
    }

    const getSubmitQues = (user_history_id, options) => {
        setShowLoader(true);
        let data = {
            user_history_id,
            question_options : options
        }
        api({ contentType: true, auth: true }).post('TakeTestService/submitQ', data)
        .then((response) => {
            if (response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: ANSRESULT,
                    payload: response.data.result
                });
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }

    const getNextQues = (user_id, module_id, attempt) => {
        setShowLoader(true);
        let data = {
            module_id,
            user_id,
            attempt
        }
        api({ contentType: true, auth: true }).post('TakeTestService/nextQ', data)
        .then((response) => {
            if (response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: QUESTION,
                    payload: response.data
                });
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }
    
    const finishTest = (user_id, module_id, attempt) => {
        setShowLoader(true);
        let data = {
            module_id,
            user_id,
            attempt
        }
        api({ contentType: true, auth: true }).post('TakeTestService/submitTest', data)
        .then((response) => {
            // console.log(response.data, 'response.data');
            if (response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: TEST_RESULT,
                    payload: response.data.result.result
                });
                clearPrepare();
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }

    const clearTestResult = () => {
        dispatch({
            type: TEST_RESULT,
            payload: ''
        });
    }
    
    return (
        <DashContext.Provider
            value={{
                ...dashtState,
                getDashList: getDashList,
                getDashPrepare: getDashPrepare,
                clearPrepare: clearPrepare,
                getSubmitQues: getSubmitQues,
                getNextQues: getNextQues,
                finishTest: finishTest,
                clearTestResult: clearTestResult,
                clearDashList: clearDashList
            }}
        >
            {props.children}
            {showLoader && <Loader onlyLoading />}
        </DashContext.Provider>
    );
}

export default DashProvider;


// WEBPACK FOOTER //
// ./contexts/provider/DashContext.js